import { useTranslation } from "react-i18next";
import PlatformCards, { IPurePlatformCard } from "../PlatformCards";
import TitleWithTooltip from "src/common/components/TitleWithTooltip/TitleWithTooltip";

export const PlatformsSelectedForPublication = ({
  selectedPlatforms,
}: {
  selectedPlatforms: string[];
}) => {
  const { t } = useTranslation();

  const selectedCards = PlatformCards.filter((pc: IPurePlatformCard) =>
    selectedPlatforms.includes(pc.id),
  );

  const needsContact = selectedCards.some(
    (e) => e.id === "iPhone" || e.id === "iPad" || e.id === "MacOS" || e.id === "WebGLApp_scorm",
  );

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex items-center justify-between mb-3">
        <TitleWithTooltip
          title={t("pages.projectGroup.publish.confirmationBeforePublish.selectedPlatforms")}
          tooltip={t("tooltip.platformsForPublicationExplanation")}
          className="text-xs font-semibold text-gray-500 uppercase tracking-wide"
        />
        <span className="bg-emerald-100 text-emerald-700 text-xs font-bold px-2.5 py-0.5 rounded-full">
          {selectedCards.length}
        </span>
      </div>

      <div className="flex flex-wrap gap-2">
        {selectedCards.map((card, i) => (
          <div
            key={`${card.id}-${i}`}
            className="flex flex-col items-center justify-center px-3 py-2 border border-emerald-300 rounded-lg bg-emerald-50/50"
          >
            {card.component}
          </div>
        ))}
      </div>

      {needsContact && (
        <div className="mt-3 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg flex items-start gap-2">
          <span className="text-amber-500 shrink-0 mt-0.5">&#9888;</span>
          <span className="text-amber-700 text-xs leading-relaxed">
            {t("pages.projectGroup.publish.contactNeededWarning")}
          </span>
        </div>
      )}
    </div>
  );
};

export default PlatformsSelectedForPublication;
